import React from 'react'
import sections from 'src/components/sections'
import SectionWrapper from 'src/containers/SectionWrapper'
import { getSafeComponent } from 'src/utils/component'
import type { KeyedSection } from 'src/hooks/useCustomisation'

interface DynamicSectionsProps {
  keyedSections: KeyedSection[]
  sortingSectionId: string
  passingProps?: Record<string, unknown>
}

const DynamicSections = ({
  keyedSections,
  sortingSectionId,
  passingProps
}: DynamicSectionsProps): JSX.Element => (
  <>
    {keyedSections.map((section, index) => {
      if (!section.type || section.options?.visibleForPreview === false) {
        return null
      }

      const SectionComponent = getSafeComponent(sections[section.type])

      return (
        <SectionWrapper
          id={section.id}
          key={section.id}
          sorting={sortingSectionId === section.id}
        >
          <SectionComponent id={section.id} passingProps={passingProps} index={index} />
        </SectionWrapper>
      )
    })}
  </>
)

export default DynamicSections
